module.exports = __webpack_public_path__ + "static/media/photo-5.8d79062b.avif";